import React from "react";
import ReactDom from "react-dom";
import { enableES5 } from "immer";
import { DatabaseId } from "../lib/types/types";
import { logger } from "../lib/utils/logger/logger";
import { assertValidHtmlElement, assertValidProgramId } from "../lib/types/assertions";
import { RequestOrganizationForm } from "../components/RequestOrganization/RequestOrganizationFormComponent";

export class RequestOrganizationFormEs5 {
  element: HTMLElement;

  programId: DatabaseId;

  constructor(element: HTMLElement, programId: DatabaseId) {
    // In case the 'new' keyword isn't used by es5 devs
    if (!(this instanceof RequestOrganizationFormEs5)) {
      throw new Error(
        'Method "render" not found. Did you use the "new" keyword when instantiating RequestOrganizationForm?',
      );
    }

    logger.info(`Constructing RequestOrganizationFormEs5 ${programId}`);
    assertValidHtmlElement(element);
    assertValidProgramId(programId);
    this.element = element;
    this.programId = programId;

    this.render();
  }

  componentDidMount() {
    enableES5(); // https://sheerid.atlassian.net/browse/UX-362
  }

  render() {
    ReactDom.render(<RequestOrganizationForm programId={this.programId} />, this.element);
  }
}
